exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".requirementTable{margin-left:-21px;margin-right:-21px;box-shadow:0px 5px 5px rgba(0,0,0,.1607843137);border-radius:10px}.requirementTable .rdt_TableCol .sc-evZas{font-size:14px;color:rgba(0,0,0,.6)}.requirementTable .req-head{font-weight:bold;font-size:14px}.requirementTable .received-date{display:flex;flex-direction:column}.requirementTable .rdt_Pagination{color:#000;padding-top:40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/ActivityCenter/SubComponents/RequirementTable.scss
// module id = 1730
// module chunks = 101